var loadChunk = __webpack_require__.e;
__webpack_require__.e = (chunkId, fetchPriority) => {
	var interceptor = self["__chunkLoadInterceptor__"];
	var load = () => (loadChunk(chunkId, fetchPriority));
	return typeof interceptor === "function" ? interceptor(chunkId, load) : load();
};